import React, { Component } from 'react';
import { Image } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withLocalize } from 'react-localize-redux';
import { toast } from 'react-toastify';

import { General } from './constant';


class NotFound extends Component {
  componentDidMount() {
    const { translate } = this.props;
    const emptyCallback = () => {};
    const defaultConfig = {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 5000,
      onClose: emptyCallback
    };
    const type = 'error';
    toast[type](translate('pageNotFound'), defaultConfig);
  }
  render() {
    return (
      <div className='full-width center'>
        <Helmet>
          <title>Page Not Found | Hackhub</title>
        </Helmet>
        <Image src={General.notFound} />
        <button
          className='standard-btn'
          onClick={() => { this.props.push('/'); }}
        >
          <a>Go Back</a>
        </button>
      </div>
    );
  }
}

export default compose(
  withRouter,
  withLocalize,
  connect(null, { push })
)(NotFound);



// WEBPACK FOOTER //
// ./src/components/common/notFound.js